import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import MobileMenu from './MobileMenu';

export default function Hamburger({
    clients,
    changeClient,
    currentClient,
    currentApp,
    currentUser,
    activeSubnavItem,
    navigateToUrl,
    className,
}) {
    const [show, setShow] = useState(false);

    return (
        <>
            <button
                className={classNames(
                    'mr-6 h-8 w-8 focus:outline-none focus-visible:ring-2',
                    className,
                )}
                onClick={() => {
                    setShow(true);
                }}
            >
                <HamburgerSVG />
            </button>
            <MobileMenu
                show={show}
                setShow={setShow}
                changeClient={changeClient}
                currentClient={currentClient}
                currentApp={currentApp}
                currentUser={currentUser}
                activeSubnavItem={activeSubnavItem}
                clients={clients}
                navigateToUrl={navigateToUrl}
            />
        </>
    );
}

function HamburgerSVG() {
    return (
        <div className="pr-2 py-1">
            <svg
                viewBox="0 0 21 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <line
                    x1="1"
                    y1="13"
                    x2="16"
                    y2="13"
                    stroke="#0C69EA"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <line
                    x1="1"
                    y1="7"
                    x2="20"
                    y2="7"
                    stroke="#0C69EA"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <line
                    x1="1"
                    y1="1"
                    x2="20"
                    y2="1"
                    stroke="#0C69EA"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
}
